import { getPendingVoters, deletePendingVoter } from './offlineDB';
import { axios } from '../contexts/AuthContext';

// Sync all pending offline voters to server
export async function syncPendingVoters(onProgress) {
  const pending = await getPendingVoters();
  if (pending.length === 0) return { synced: 0, failed: 0 };

  let synced = 0, failed = 0;

  for (const voter of pending) {
    try {
      const { localId, savedAt, synced: _, ...voterData } = voter;
      await axios.post('/voters', { ...voterData, mobile: voterData.phone });
      await deletePendingVoter(localId);
      synced++;
      if (onProgress) onProgress({ synced, total: pending.length, name: voterData.name });
    } catch (err) {
      failed++;
      console.error('Sync failed for voter:', voter.name, err.message);
    }
  }

  return { synced, failed, total: pending.length };
}

// Auto sync when coming back online
export function setupAutoSync(callback) {
  const handler = async () => {
    if (navigator.onLine) {
      const result = await syncPendingVoters();
      if (result.synced > 0 && callback) callback(result);
    }
  };
  window.addEventListener('online', handler);
  return () => window.removeEventListener('online', handler);
}